import ticketRequest from "../requests/ticketRequest";
import { fileDownload } from "./fileDownload";
import { requestError } from "./requestError";

export default function downloadDocument(
  sessionExpiredDispatcher,
  loginStateDispatcher
) {
  return (documentIndex, documentId) => {
    ticketRequest()
      .then(response => {
        const ticket = response.data.ticket;
        const path = `api/file/${documentIndex}/${documentId}?ticket=${ticket}`;
        fileDownload(path);
      })
      .catch(requestError(sessionExpiredDispatcher, loginStateDispatcher));
  };
}
